import * as React from 'react';

function SvgTimer48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='48'
      height='48'
      viewBox='0 0 48 48'
      {...props}
    >
      <path
        stroke='currentColor'
        fill='currentColor'
        strokeWidth={0.25}
        d='M31.408 2.07h-6.594v5.903c5.87.258 11.532 3.22 15.064 7.942 3.657 4.888 4.886 11.495 3.135 17.445-1.653 5.613-5.92 10.398-11.353 12.677-5.88 2.467-12.93 1.873-18.327-1.588C7.79 40.893 4.2 34.475 4.2 27.764c0-5.579 2.513-11.092 6.703-14.838l-2.526-3.16 1.26-1.008 2.513 3.144c.273-.205.551-.403.835-.594A19.928 19.928 0 0123.2 7.973V2.07h-6.593V.455h14.8v1.614zm-7.46 7.5c-5.643.027-11.145 2.802-14.519 7.311-3.366 4.5-4.483 10.574-2.878 16.023 1.521 5.17 5.474 9.584 10.48 11.667 5.505 2.29 12.124 1.65 17.1-1.691 4.9-3.29 8.051-9.035 8.07-15.057.02-6.048-3.176-11.997-8.299-15.326a18.308 18.308 0 00-9.836-2.927h-.117zm.866 34.695H23.2v-3h1.614v3zm0-15.363l8.73 7.76-1.072 1.205-9.272-8.241V13.515h1.614v15.387zm15.194.169h-3v-1.614h3v1.614z'
      ></path>
    </svg>
  );
}

export default SvgTimer48;
